/** `myAwpStatus` data-access layer: the member's last Annual Wellness Program exam and next-eligible dates. */

import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyAwpStatusDocument, type MyAwpStatusQuery } from '@/graphql/generated/graphql';

/** Both dates are `yyyy-MM-dd`, or null for a member who has never completed an exam. */
export interface AwpStatus {
  lastAwpDate: string | null;
  nextAwpDueDate: string | null;
}

export const awpStatusKey = ['member', 'myAwpStatus'] as const;

export function requestMyAwpStatus(): Promise<MyAwpStatusQuery> {
  return gqlRequest(MyAwpStatusDocument);
}

function emptyToNull(value: string | null | undefined): string | null {
  return value ? value : null;
}

export function mapToAwpStatus(raw: MyAwpStatusQuery): AwpStatus {
  return {
    lastAwpDate: emptyToNull(raw.myAwpStatus.lastAwpDate),
    nextAwpDueDate: emptyToNull(raw.myAwpStatus.nextAwpDueDate),
  };
}
